var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Section",
    [
      _c("SectionHeader", {
        attrs: { title: _vm.$t("apps.billing.message.summarybyservice") }
      }),
      _vm._v(" "),
      _c(
        "FormRow",
        [
          _c(
            "Col",
            { attrs: { className: "col-lg-12" } },
            [
              _c("BaseTable", {
                staticClass: "custom-table",
                attrs: { tableClass: "table-bordered", hidePagination: "" },
                scopedSlots: _vm._u([
                  {
                    key: "thead",
                    fn: function() {
                      return [
                        _c("thead", [
                          _c("tr", [
                            _c("th", { staticStyle: { width: "125px" } }, [
                              _vm._v(_vm._s(_vm.$t("apps.billing.label.item")))
                            ]),
                            _vm._v(" "),
                            _c("th", [
                              _vm._v(
                                _vm._s(_vm.$t("apps.billing.label.detail"))
                              )
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "text-center" }, [
                              _vm._v(
                                _vm._s(_vm.$t("apps.billing.label.usedfree"))
                              )
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "text-center" }, [
                              _vm._v(
                                _vm._s(_vm.$t("apps.billing.label.usedall"))
                              )
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "text-center" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("apps.billing.label.usedwithcharge")
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticClass: "text-right",
                                staticStyle: { width: "140px" }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("apps.billing.label.payamount"))
                                )
                              ]
                            )
                          ])
                        ])
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "tbody",
                    fn: function() {
                      return [
                        _c(
                          "tbody",
                          [
                            _vm._l(_vm.apps, function(item, index) {
                              return _c("tr", { key: index }, [
                                _c("td", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item.app.title) +
                                      "\n            "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  {
                                    staticStyle: {
                                      "border-right": "1px solid #dee2e6"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.module.title) +
                                        "\n            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-center" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item.freeUsedTotal) +
                                      "\n            "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-center" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item.usedTotal) +
                                      "\n            "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-center" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item.chargeUsedTotal) +
                                      "\n            "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "text-right" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.getCurrencyWithNumber(
                                          _vm.numberel(
                                            item.amountTotal,
                                            "0,0.00"
                                          )
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ])
                              ])
                            }),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("apps.billing.message.branch")
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("apps.billing.message.branchcount")
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.numberel(_vm.data.branch.freeTotal)
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.numberel(
                                        _vm.data.branch.countAllTotal
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("apps.billing.message.branches", {
                                        number: _vm.numberel(
                                          _vm.data.branch.countChargeTotal
                                        )
                                      })
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.getCurrencyWithNumber(
                                        _vm.numberel(
                                          _vm.data.branch.amountTotal,
                                          "0,0.00"
                                        )
                                      )
                                    ) +
                                    "\n            "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("apps.billing.message.warehouse")
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "apps.billing.message.warehousecount"
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.numberel(_vm.data.warehouse.freeTotal)
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.numberel(
                                        _vm.data.warehouse.countAllTotal
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "apps.billing.message.warehouses",
                                        {
                                          number: _vm.numberel(
                                            _vm.data.warehouse.countChargeTotal
                                          )
                                        }
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.getCurrencyWithNumber(
                                        _vm.numberel(
                                          _vm.data.warehouse.amountTotal,
                                          "0,0.00"
                                        )
                                      )
                                    ) +
                                    "\n            "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("apps.billing.message.user")
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("apps.billing.message.usercount")
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.numberel(_vm.data.user.freeTotal)
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.numberel(_vm.data.user.countAllTotal)
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("apps.billing.message.users", {
                                        number: _vm.numberel(
                                          _vm.data.user.countChargeTotal
                                        )
                                      })
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.getCurrencyWithNumber(
                                        _vm.numberel(
                                          _vm.data.user.amountTotal,
                                          "0,0.00"
                                        )
                                      )
                                    ) +
                                    "\n            "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { attrs: { rowspan: "2" } }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("apps.billing.message.storage")
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("apps.billing.message.application")
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.numberel(_vm.data.record.freeTotal)
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "text-center",
                                  staticStyle: { position: "relative" }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "link",
                                      on: {
                                        click: function($event) {
                                          return _vm.onOpenUsageModal(
                                            _vm.UsageInfoType.Record
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.numberel(
                                              _vm.data.record.countAllTotal
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("apps.billing.message.records", {
                                        number: _vm.numberel(
                                          _vm.data.record.countChargeTotal
                                        )
                                      })
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.getCurrencyWithNumber(
                                        _vm.numberel(
                                          _vm.data.record.amountTotal,
                                          "0,0.00[00000000]"
                                        )
                                      )
                                    ) +
                                    "\n            "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("apps.billing.message.file")
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("apps.billing.message.files", {
                                        number: _vm.numberel(
                                          _vm.data.file.freeTotal,
                                          "0,0.00"
                                        )
                                      })
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "link",
                                    on: {
                                      click: function($event) {
                                        return _vm.onOpenUsageModal(
                                          _vm.UsageInfoType.File
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("apps.billing.message.files", {
                                            number: _vm.numberel(
                                              _vm.data.file.countAllTotal,
                                              "0,0.00"
                                            )
                                          })
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("apps.billing.message.files", {
                                        number: _vm.numberel(
                                          _vm.data.file.countChargeTotal,
                                          "0,0.00"
                                        )
                                      })
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.getCurrencyWithNumber(
                                        _vm.numberel(
                                          _vm.data.file.amountTotal,
                                          "0,0.00[00000000]"
                                        )
                                      )
                                    ) +
                                    "\n            "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", { attrs: { rowspan: "3" } }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("apps.billing.message.addon")
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("apps.billing.message.linemessage")
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.numberel(
                                        _vm.data.messageLine.freeTotal
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "link",
                                    on: {
                                      click: function($event) {
                                        return _vm.onOpenUsageModal(
                                          _vm.UsageInfoType.MessageLine
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.numberel(
                                            _vm.data.messageLine.countAllTotal
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "apps.billing.message.linemessages",
                                        {
                                          number: _vm.numberel(
                                            _vm.data.messageLine
                                              .countChargeTotal
                                          )
                                        }
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.getCurrencyWithNumber(
                                        _vm.numberel(
                                          _vm.data.messageLine.amountTotal,
                                          "0,0.00"
                                        )
                                      )
                                    ) +
                                    "\n            "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("apps.billing.message.email")
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.numberel(_vm.data.email.freeTotal)
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "link",
                                    on: {
                                      click: function($event) {
                                        return _vm.onOpenUsageModal(
                                          _vm.UsageInfoType.Email
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.numberel(
                                            _vm.data.email.countAllTotal
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("apps.billing.message.emails", {
                                        number: _vm.numberel(
                                          _vm.data.email.countChargeTotal
                                        )
                                      })
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.getCurrencyWithNumber(
                                        _vm.numberel(
                                          _vm.data.email.amountTotal,
                                          "0,0.00"
                                        )
                                      )
                                    ) +
                                    "\n            "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tr", [
                              _c("td", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("apps.billing.message.qrcode")
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.numberel(_vm.data.qrcode.freeTotal)
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "link",
                                    on: {
                                      click: function($event) {
                                        return _vm.onOpenUsageModal(
                                          _vm.UsageInfoType.QRCode
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.numberel(
                                            _vm.data.qrcode.countAllTotal
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-center" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("apps.billing.message.qrcodes", {
                                        number: _vm.numberel(
                                          _vm.data.qrcode.countChargeTotal
                                        )
                                      })
                                    ) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.getCurrencyWithNumber(
                                        _vm.numberel(
                                          _vm.data.qrcode.amountTotal,
                                          "0,0.00"
                                        )
                                      )
                                    ) +
                                    "\n            "
                                )
                              ])
                            ])
                          ],
                          2
                        )
                      ]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("Col", { attrs: { className: "col-lg-12" } }, [
            _c("div", { staticClass: "summary-container" }, [
              _c("div", { staticClass: "text" }, [
                _c("strong", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("apps.billing.message.total")) +
                      "\n        "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.getCurrencyWithNumber(
                        _vm.numberel(_vm.data.total, "0,0.00[0000]")
                      )
                    ) +
                    "\n      "
                )
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d422234", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d422234","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/combine/ServiceUsedSummary.vue
// module id = null
// module chunks = 